import { Button, Dropdown, Nav } from "react-bootstrap"
import {
    faCalendar,
    faPencil,
    faCalendarDay,
    faEllipsisVertical,
    faFileCsv,
    faFileExport,
    faFileImport,
    faUser,
    faUserPlus,
    faPlus,
    faUserXmark
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconBrandMeta, IconLayout2, IconListDetails, IconShare3 } from "@tabler/icons-react"
import { customStyles, handleExportData } from '../../Utils/helpers/commonhelper'
import { toast } from "sonner"
import Select, { components } from "react-select"
import { imageURL } from "../../Utils/constants/constant"
import { DropdownItemWithActions } from '../../pages/DropdownItemWithActions'
import { FilterPagination } from '../../pages/FIlterPagination'
import DeleteModal from '../DeleteModal'
import { Filter } from '../../pages/Filter'
import useLocalStorageState from "use-local-storage-state"
import { useLocation, useNavigate } from "react-router-dom"
import { useEffect, useMemo, useRef, useState } from "react"
import { DeleteRequest, GetRequest, PostRequest, PutRequest } from "../../Utils/hooks/ApiHandler"
import face1 from "../../Utils/assets/img/faces/5.jpg"
import face2 from "../../Utils/assets/img/faces/6.jpg"
import face3 from "../../Utils/assets/img/faces/7.jpg"
import { PipelineShareModal } from "../../pages/PipelineShareModal"
import useCommonData from "../../Utils/actions/advanceFilteringAction"
import Tooltip from "@mui/material/Tooltip"
import { FbModal } from "../../pages/FbModal"
import { FbFormModal } from "../../pages/FbFormModal"
import { ColumnConfigurator } from "../../pages/ColumnConfigurator"
import { ManageListDropdown } from "../../pages/ManageListDropdown"

export const LeadsHeader = ({
    heading,
    setHeading,
    permissionAssigned,
    canEdit_canDownload,
    filterCategories,
    setFilterCategories,
    filterDropPipelineStage,
    leadsData,
    filterDropdown,
    setFilterDropdown,
    pipelines,
    selectedPipelineId,
    setSelectedPipelineId,
    // cuz the main parent needed in order to make sure that offset becames 0 when search is performed
    setDebouncedSearch,
    currView,
    setCurrView,
    leadPipelineGrant,
    leadGrant,
    setCreatePipeline,
    encodePipelineId,
    handleAddLead,
    setEditPipeline,
    setActiveOffset,
    setEncodedId,
    parsedSharedUsers,
    selectedPipeline,
    selectedStageId,
    filterStates,
    setFilterState,
    leadsApiData,
    queryKey,
    setTempFilterData,
    columns,
    setColumns,
    columnOptions,
    refetchLeads
}) => {

    const locatiion = useLocation()
    const fbCode = locatiion.search?.split("code=")[1] || null

    // Session storage and authentication setup
    const [customer, setCustomer] = useLocalStorageState("customer")
    const navigate = useNavigate()
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication

    // API headers configuration
    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }


    // // Available lead fields for column configuration (excluding permanent fields)
    // const columnOptions = [
    //     { id: "serial", label: "#", mandatory: true },
    //     { id: "name", label: "Name", mandatory: true },
    //     { id: "contact_phone", label: "Phone" },
    //     { id: "email", label: "Email" },
    //     { id: "requirement", label: "Requirement" },
    //     { id: "pipelineStageName", label: "Pipeline Stage Name" },
    //     { id: "lead_status", label: "Lead Status" },
    //     { id: "budget", label: "Budget" },
    //     { id: "source_title", label: "Source" },
    //     { id: "expected_closure_date", label: "Expected Closure Date" },
    //     // { id: "followup_date", label: "Follow Up Date" },
    //     // { id: "expected_closure_time", label: "Expected Closure Time" },
    //     // { id: "followup_time", label: "Follow Up Time" },
    // ]


    // filter seazrch bar input state
    const [filterSearchInput, setFilterSearchInput] = useState("")
    // state for storing the owner who created the current pipeline 
    const [added_by, setAddedBy] = useState(null)
    // loading state for deleting
    const [loading, setLoading] = useState(false)
    // fitered categories to store the search input filter categories
    const [filteredCategories, setFilteredCategories] = useState([])
    // Add states for filter pagination and search
    const [filterOffset, setFilterOffset] = useState(0);
    const [filterLimit, setFilterLimit] = useState(5);
    const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("");
    const [filterPageCount, setFilterPageCount] = useState(0);
    // isediting state for undoing the edit state in the filter name update in the heading dropdown
    const [editingId, setEditingId] = useState(false);
    // filter state to store the data to pass to delete and edit handler for filter
    const [filterData, setFilterData] = useState(null);
    // edit value state fot the filter card name edit
    const [editValue, setEditValue] = useState();
    // delete state for filter
    const [confirmFilterDelete, setFilterDelete] = useState(false);
    // for dropdown of the filter cards being created by the user
    const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false)
    const filterCategoriesDropRef = useRef(null)
    // Search states for debounced search
    const [searchInput, setSearchInput] = useState("")
    // to render the pipelines
    const pipelineOptions = pipelines.map((el) => ({
        value: el.id,
        label: el.pipeline_name,
    }));

    // facebook lead sync states
    const [fbModal, setFbModal] = useState(false)
    // fb form modal states
    const [pageFormData, setPageFormData] = useState(null)
    const [showFbFormModal, setShowFbFormModal] = useState(false)

    // loading state for exporting data
    const [isExporting, setIsExporting] = useState(false)
    // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
    const [isInitialized, setIsInitialized] = useState(false);
    // pipeline share modal state
    const [shareModal, setShareModal] = useState(false)
    // to filter out the unique owners and show profile image across them
    const DEFAULT_AVATAR = [face1, face2, face3] // or any default image you want
    const uniqueOwners = useMemo(() => {
        if (!leadsData?.length) return []
        const ownerMap = new Map()
        leadsData?.forEach(lead => {
            if (lead.owner_id && !ownerMap.has(lead.owner_id)) {
                ownerMap.set(lead.owner_id, {
                    owner_id: lead.owner_id,
                    profile_img: lead.profile_img
                })
            }
        })
        return Array.from(ownerMap.values())
    }, [leadsData])

    const leadStatusOptions = [
        { value: 'lost', label: "Lost" },
        { value: "unqualified", label: "Unqualified" }
    ]

    // common advance filter api calls that will be needed everywhere
    const { leadOwner, lead_source, company, contacts } = useCommonData({
        leadOwner: true,
        leadSource: true,
        companies: true,
        contacts: true
    })

    const leadsStaticListOptions = [
        {
            key: "All Leads",
            icon: <FontAwesomeIcon icon={faUser} style={{ width: "13px", height: "13px", marginRight: "9px" }} />
        },
        {
            key: "Leads Created By Me",
            icon: <FontAwesomeIcon icon={faUserPlus} style={{ width: "15px", height: "15px", marginRight: "9px" }} />
        },
        {
            key: "Leads Created Today",
            icon: <FontAwesomeIcon
                icon={faCalendarDay}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Leads Created this Month",
            icon: <FontAwesomeIcon
                icon={faCalendar}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Unqualified Leads",
            icon: <FontAwesomeIcon
                icon={faUserXmark}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "Lost Leads",
            icon: <FontAwesomeIcon
                icon={faUserXmark}
                style={{
                    width: "13px",
                    height: "13px",
                    marginRight: "9px",
                }}
            />
        },
        {
            key: "My Today Followup",
            icon: <FontAwesomeIcon icon={faUserXmark} style={{ width: "13px", height: "13px", marginRight: "9px" }} />
        },
    ]

    //  filter dropdown options
    const dropdownOptions = [
        { value: "contact_id", label: "Contact", option: contacts },
        { value: "owner_id", label: "Owner", option: leadOwner },
        { value: "company_id", label: "Company Name", option: company },
        { value: "pipeline_stage_id", label: "Pipeline Stage", option: filterDropPipelineStage },
        { value: "closure_date", label: "Closure Date", type: "date-range" },
        { value: "followup_date", label: "FollowUp Date", type: "date-range" },
        { value: "lead_source_id", label: "Lead Source", option: lead_source },
        { value: "lead_no", label: "Lead Number" },
        { value: 'lead_status', label: "Leads Status", option: leadStatusOptions },
        { value: "created_at", label: "Created at", type: "date-range" },
    ];

    // sub filter dropdown option
    const subFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "contains", label: "Contains" },
        { value: "not_contains", label: "Not-Contains" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
        { value: "is_empty", label: "Is Empty" },
        { value: "is_not_empty", label: "Is Not Empty" },
        { value: "begins_with", label: "Begins With" },
        { value: "between", label: "Between" },
    ];
    const customSubFilter = [
        { value: "equals", label: "Equals" },
        { value: "not_equals", label: "Not-Equals" },
        { value: "is_set", label: "Is Set" },
        { value: "is_not_set", label: "Is Not Set" },
        { value: "in", label: "In" },
        { value: "not_in", label: "Not-In" },
    ];

    const leadImportFields = [
        // { id: "company_no", label: "Company No.", required: true },
        { id: "contact_name", label: "Contact Name", required: true },
        { id: "pipeline", label: "Pipeline", required: true },
        { id: "pipeline_stage", label: "Pipeline Stage", required: true },

        { id: "owner", label: "Owner", required: true },
        {
            id: "expected_closure_date",
            label: "Expected Closure Date",
            required: true,
        },
        {
            id: "expected_closure_time",
            label: "Expected Closure Time",
            required: true,
        },
        { id: "requirement", label: "Requirement", required: true },
        { id: "product_services", label: "Product & Services", required: true },
        { id: "quantity", label: "Quantity", required: true },
        { id: "budget", label: "Budget", required: true },
        { id: "lead_source", label: "Lead Source", required: true },
        // { id: "follow_up_date", label: "Follow Up Date", required: true },
        // { id: "follow_up_time", label: "Follow Up Time", required: true },
        // { id: "feedback", label: "Feedback", required: true },
    ];
    //menulist for add new products and services button in dropdown
    const MenuList = (props) => {
        return (
            <>
                <components.MenuList {...props}>
                    {props.children}
                    <div
                        style={{
                            padding: "10px",
                            borderTop: "1px solid #ddd",
                            textAlign: "center",
                            cursor: "pointer",
                            color: "#2184ff",
                            fontSize: '0.9rem'
                        }}
                        onClick={() => {
                            // trigger your modal open here
                            if (!leadGrant?.isCreate) {
                                toast.warning("You are not authorized for this action!")
                                return
                            }
                            props.selectProps.onAddNew();
                        }}
                    >
                        + Create Pipeline
                    </div>
                </components.MenuList>
            </>
        );
    };

    // if fbcode exist for the respective fb login then had to hit the post api for facebook
    useEffect(() => {
        if (fbCode === null) return
        (
            async () => {
                try {
                    const payload = {
                        code: fbCode,
                        customer_id: customer.customer_details?.customer_id,
                        user_login_id: customer.customer_details?.id
                    }
                    const res = await PostRequest('facebook/getFBData', payload, false, { headers }, extras)
                    if (res.status === "fail" || res.success === false) {
                        return
                    }
                    toast.success(res.message)
                } catch (error) {
                    return
                }
            }
        )()
    }, [fbCode])

    // Debounced search effect with 500ms delay
    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchInput)
            if (currView === "list") {
                setActiveOffset(0)
            }
        }, 500)

        return () => clearTimeout(timer)
    }, [searchInput, currView])

    // Clear search function
    const clearSearch = () => {
        setSearchInput("")
        setDebouncedSearch("")
        if (currView === "list") {
            setActiveOffset(0)
        }
    }

    useEffect(() => {
        if (filterCategories?.length > 0 && !isInitialized) {
            const lastHeading = localStorage.getItem("leads_last_heading")
            const existingFilter = filterCategories.find((filter) => filter.card_name === lastHeading)
            setHeading(existingFilter ? lastHeading : "All Leads")
            setIsInitialized(true)
        }
    }, [filterCategories, isInitialized])

    // for searching certain lead
    useEffect(() => {
        if (!filterSearchInput || filterSearchInput.trim() === "") {
            // If no search input, show all categories
            setFilteredCategories(filterCategories)
        } else {
            // Filter categories based on search input
            const filtered = filterCategories.filter(category =>
                category.card_name.toLowerCase().includes(filterSearchInput.toLowerCase())
            )
            setFilteredCategories(filtered)
        }
    }, [filterSearchInput, filterCategories])


    //  storing all contacts to a state to use it in the custom dropdown for the dynamic fields
    useEffect(() => {
        if (
            leadsApiData &&
            leadsApiData.filter_data &&
            leadsApiData.filter_data[0] &&
            leadsApiData.filter_data[0].filter_values
        ) {
            const values = leadsApiData.filter_data[0].filter_values;
            const parsedState = JSON.parse(values);
            const filteredArray = parsedState?.map((state) => {
                // Find the corresponding dropdown option to get the display label and potential nested options
                const dropdownOption = dropdownOptions.find(
                    (opt) => opt.value === state.label_name
                );

                let mappedOptions = null;
                if (dropdownOption?.option && Array.isArray(dropdownOption.option)) {
                    // Replicate the mapping logic from handleAddFilter
                    if (dropdownOption.value === "owner_id") {
                        mappedOptions = dropdownOption.option.map((opt) => ({
                            value: opt.leadId,
                            label: opt.leadName,
                        }));
                    } else if (dropdownOption.value === "lead_source_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.lead_source_id,
                            label: opt.source_title,
                        }));
                    } else if (dropdownOption.value === "company_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.company_id,
                            label: opt.company_name,
                        }));
                    } else if (dropdownOption.value === "contact_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.contactId,
                            label: opt.contact_name
                        }));
                    } else if (dropdownOption.value === "pipeline_stage_id") {
                        mappedOptions = dropdownOption.option?.map((opt) => ({
                            value: opt.stage_id,
                            label: opt.stage_name
                        }));
                    }
                }
                return {
                    id: state.label_name, // IMPORTANT: Generate a new unique ID for React keys
                    field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
                    label_name: dropdownOption ? dropdownOption.label : state.label_name,
                    option: mappedOptions,
                    subFilterType: state.label_query,
                    value: state.label_query === "between" ? { start: state.label_value[0], end: state.label_value[1] } : state.label_value,
                };
            });
            setFilterState(filteredArray);
        } else {
            setFilterState([]);
        }
        setAddedBy(leadsApiData?.pipeline_data?.["added_by"])
    }, [queryKey, leadsApiData]);

    // useeeffect for fetching the created advance filters
    const fetchFilterCardCategories = async () => {
        try {
            const res = await GetRequest(
                `common/fetchFilterCard/${customer.customer_details?.customer_id}/leads?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            );

            if (res.status === "fail" || res.success === false) {
                return;
            }

            setFilterCategories(res.data);

            // Calculate page count if total_count is available in response
            if (res.total_count) {
                setFilterPageCount(Math.ceil(res.total_count / filterLimit));
            }
        } catch (error) {
            toast.error("Error fetching filters");
        }
    }
    useEffect(() => {
        fetchFilterCardCategories()
    }, [heading]);

    // fb lead sync form handler
    const handleFbLeadSync = async () => {
        try {
            const res = await GetRequest(`facebook/fetchPages/${customer.customer_details?.customer_id}`, { headers }, extras)
            if (res.status === "fail" || res.success === false) {
                return
            }
            // do something
            res.data && setPageFormData(res.data)
            setShowFbFormModal(true)
        } catch (error) {
            return
        }
    }

    // edit handler for filter heading
    const handleFilterEdit = async () => {
        try {
            if (editValue === "") return
            if (filterData === null) return
            const updatePayload = {
                customer_id: customer.customer_details?.customer_id,
                user_login_id: customer.customer_details?.id,
                filter_id: filterData.id,
                card_name: editValue,
                description: ""
            }
            const res = await PutRequest('contacts/updateFilterName', updatePayload, { headers }, { customer, setCustomer, rf: headers.Authentication, navigate })
            if (res.status === false || res.success === "fail") {
                setFilterDropdown(false)
                return
            }
            if (res.status === "success") {
                setEditingId(null)
                fetchFilterCardCategories()
                setFilterDropdown(false)
            }
        } catch (error) {
            toast.error("Error Updating Filter")
        }
    }
    // delete handler for filter delete
    const handleFilterDelete = async () => {
        try {
            if (filterData === null) return
            setLoading(true)
            const res = await DeleteRequest(`common/deleteFilter/${filterData.id}`, { headers }, { customer, setCustomer, rf: headers.Authentication, navigate })
            if (res.status === "fail") {
                toast.error(res.message)
                setLoading(false)
                return
            }
            if (res.success === false) {
                toast.error(res.message)
                setLoading(false)
            }
            setFilterDropdown(false)
            setFilterDelete(false)

            setHeading("All Leads")
            fetchFilterCardCategories()
            localStorage.setItem("leads_last_heading", "All Leads")
            toast.success(res.message)
            setLoading(false)
        } catch (error) {
            toast.error("Error Deleting Filter")
            setLoading(false)
        }
    }

    return (
        <>
            <div className="d-flex justify-content-between align-content-center px-0 w-100 py-0 pt-3 my-4 mb-2">
                <div className="d-flex align-items-center gap-1" style={{ width: "23%" }}>
                    <h3 className="mb-0 me-1" style={{ fontWeight: 200, fontSize: "22px", textTransform: "capitalize" }}>
                        {heading}
                    </h3>

                    {/* heading filter dropdown */}
                    <ManageListDropdown
                        heading={heading}
                        setHeading={setHeading}
                        categories={filterCategories}
                        storageKey="leads_last_heading"
                        setTempFilterData={setTempFilterData}
                        onEdit={(c) => setFilterData(c)}
                        onDelete={(c) => {
                            setFilterData(c)
                            setFilterDelete(true)
                        }}
                        onUpdate={(c) => {
                            setFilterData(c)
                            handleFilterEdit()
                        }}
                        staticOptions={leadsStaticListOptions}
                        filterOffset={filterOffset}
                        setFilterOffset={setFilterOffset}
                        handleFilterPageChange={(newOffset) => setFilterOffset(newOffset.selected)}
                        filterPageCount={filterPageCount}
                        filterLimit={filterLimit}
                    />
                    {confirmFilterDelete && (
                        <DeleteModal
                            show={confirmFilterDelete}
                            onClose={() => setFilterDelete(false)}
                            onConfirm={() => handleFilterDelete(filterData)}
                            isLoading={loading}
                            message="Are you sure you want to delete this item?"
                        ></DeleteModal>
                    )}
                </div>

                <div className="avatar-list-stacked">
                    {uniqueOwners.slice(0, 5).map(owner => (
                        <div
                            key={owner.owner_id}
                            className="avatar avatar-md rounded-circle overflow-hidden"
                            style={Styles.avatar}
                        >
                            <img
                                src={owner.profile_img ? `${imageURL}${owner.profile_img}` : DEFAULT_AVATAR[Math.floor(Math.random() * DEFAULT_AVATAR.length)]}
                                alt="owner"
                                className="w-100 h-100"
                                style={{ objectFit: "cover" }}
                            />
                        </div>
                    ))}

                    {uniqueOwners.length > 5 && (
                        <a className="avatar avatar-md rounded-circle bg-primary text-fixed-white">
                            +{uniqueOwners.length - 5}
                        </a>
                    )}
                </div>

                {/* Header with pipeline selection and actions */}
                <div className="d-flex align-content-center gap-1" style={{ height: "35px" }}>

                    <style>
                        {`
                            @keyframes shim {
                                0% {
                                opacity: 1;
                                }
                                50% {
                                opacity: 0.6;
                                }
                                100% {
                                opacity: 1;
                                }
                            }
                        `}
                    </style>


                    {/* facebook leads sync button */}
                    <Tooltip
                        title={"Sync Facebook Leads"}
                        arrow
                        placement="bottom"
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    fontSize: "0.8rem",
                                    backgroundColor: "#7a3a5e",
                                    color: "white",
                                },
                            },
                            arrow: { sx: { color: "#7a3a5e" } },
                        }}
                    >
                        <div
                            onClick={() => setFbModal(true)}
                            style={{ marginRight: '5px', borderRadius: "5px", backgroundColor: "#0765fe", padding: "1px", cursor: "pointer" }}
                        >
                            <IconBrandMeta size={36} color="white" />
                        </div>
                    </Tooltip>

                    <FbModal
                        show={fbModal}
                        setShow={setFbModal}
                        facebookData={pageFormData}
                    />
                    <FbFormModal
                        show={showFbFormModal}
                        setShow={setShowFbFormModal}
                        facebookData={pageFormData}
                    />
                    {/* Pipeline selection dropdown */}
                    {
                        pipelineOptions ?
                            <Select
                                options={pipelineOptions}
                                className="input-boxi"
                                value={pipelineOptions.find(option => option.value === selectedPipelineId)}
                                onChange={(selectedOption) => {
                                    if (selectedOption.value === 'add-new-pipeline') {
                                        setCreatePipeline(true)
                                    } else {
                                        setSelectedPipelineId(selectedOption.value);
                                    }
                                }}
                                components={{ MenuList }}
                                onAddNew={() => setCreatePipeline(true)}
                                styles={{
                                    ...customStyles,
                                    placeholder: (base) => ({
                                        ...base,
                                        margin: "0px",
                                    }),
                                    control: (base) => ({
                                        ...base,
                                        height: "36px",
                                        minWidth: "180px",
                                        width: "auto",
                                        minHeight: "34px",
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        textTransform: "capitalize",
                                        fontSize: "0.9rem",
                                    }),
                                    option: (base, state) => {
                                        const isCreateOption = state.data.value === "add-new-pipeline"

                                        return {
                                            ...base,
                                            backgroundColor: state.isSelected
                                                ? "#2684FF"
                                                : state.isFocused
                                                    ? "#DEEBFF"
                                                    : "white",
                                            color: isCreateOption ? "#2684FF" : base.color,
                                            fontWeight: 400,
                                            textTransform: "capitalize",
                                            fontSize: "0.9rem",
                                            "&:active": {
                                                backgroundColor: isCreateOption ? "#DEEBFF" : "#2684FF",
                                            },
                                        }
                                    },
                                    dropdownIndicator: (base) => ({
                                        ...base,
                                        padding: "4px 8px",
                                    }),
                                    clearIndicator: (base) => ({
                                        ...base,
                                        padding: "4px 8px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "34px",
                                        padding: "0 8px",
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        margin: 0,
                                        padding: 0,
                                    }),
                                }}
                                isSearchable={true}
                                placeholder="Select pipeline..."
                            />
                            :
                            <div style={{ width: "150px", height: "34px", animation: "shim 1.3s linear infinite", backgroundColor: "#e5e5e5", borderRadius: "5px" }}></div>
                    }
                    {/* Fixed width search bar to prevent resizing */}
                    <div style={{ position: "relative", width: "200px", minWidth: "200px" }}>
                        <input
                            type="text"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            style={{
                                fontSize: "0.9rem",
                                paddingLeft: "36px",
                                paddingRight: searchInput ? "36px" : "12px",
                                width: "100%",
                            }}
                            className="form-control h-100"
                            placeholder="Search here.."
                        />
                        <i
                            className="fa-solid fa-magnifying-glass"
                            style={{ position: "absolute", marginTop: "-26px", zIndex: 1, marginLeft: "13px" }}
                        ></i>
                        {searchInput && (
                            <i
                                className="fa-solid fa-times"
                                onClick={clearSearch}
                                style={{
                                    position: "absolute",
                                    marginTop: "-26px",
                                    zIndex: 1,
                                    right: "13px",
                                    cursor: "pointer",
                                    color: "#6c757d",
                                }}
                                title="Clear search"
                            ></i>
                        )}
                    </div>

                    {/* List and card view toggle buttons */}
                    <div
                        className="px-2"
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 5,
                            border: "1px solid #7a3a5e69",
                            borderRadius: "3px",
                            background: "#ffffff",
                            padding: "4px 8px",
                        }}
                    >
                        {/* Card View Button */}
                        <div
                            className=""
                            onClick={() => {
                                setCurrView("card")
                                // setTimeout(() =>
                                //   refetchLeads()
                                //   , 300)
                            }}
                            style={{
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor: currView === "card" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            <IconLayout2
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: currView === "card" ? "#212121" : "#212121",
                                }}
                            />
                        </div>
                        {/* List View Button */}
                        <div
                            className=""
                            onClick={() => {
                                setCurrView("list")
                                // setTimeout(() =>
                                //   refetchLeads()
                                //   , 300)
                            }}
                            style={{
                                padding: "3px 5px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                backgroundColor: currView === "list" ? "#e8e8e8" : "transparent",
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            <IconListDetails
                                stroke={2}
                                style={{
                                    width: "18px",
                                    height: "18px",
                                    color: currView === "list" ? "#212121" : "#212121",
                                }}
                            />
                        </div>
                    </div>


                    {/* advance filtering */}
                    {
                        currView === 'list' &&
                        <Filter
                            filterDropdown={filterDropdown}
                            canEdit_canDownload={canEdit_canDownload}
                            setFilterDropdown={setFilterDropdown}
                            dropdownOptions={dropdownOptions}
                            filterState={filterStates}
                            setFilterState={setFilterState}
                            setHeading={setHeading}
                            subFilter={subFilter}
                            module_name={"leads"}
                            pipelineId={selectedPipelineId}
                            customSubFilter={customSubFilter}
                            setTempFilterData={setTempFilterData}
                            filterEndpoint={"common/filterQuery"}
                            applyQuery={"lead/applyFilter"}
                            view={currView == "list" ? "list" : "card"}
                        ></Filter>
                    }
                    {
                        currView === "list" &&
                        <ColumnConfigurator
                            columnOptions={columnOptions}
                            columns={columns}
                            setColumns={setColumns}
                            storageKey="leadColumns"
                            visibleKey="visibleLeadColumns"
                        />
                    }
                    {
                        canEdit_canDownload &&
                        <Dropdown as="div" className="dropdownsWithoutToggle" style={{ zIndex: 101 }}>
                            <Dropdown.Toggle as={Nav.Link} className="header-link">
                                <button
                                    className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                                    style={{ fontSize: "1rem", alignItems: "center", height: "35px", width: "2.5rem" }}
                                >
                                    <FontAwesomeIcon
                                        style={{
                                            width: "15px",
                                            height: "15px",
                                        }}
                                        icon={faEllipsisVertical}
                                    />
                                </button>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                className="defaultDropdown dropdown-menu-end"
                                style={{ width: "11rem", padding: "12px 0px", right: "3.4rem" }}
                            >
                                <Dropdown.Item
                                    onClick={() => {
                                        if (!leadGrant?.isImport) {
                                            toast.warning("You are not authorized for this action!");
                                            return;
                                        }
                                        navigate("/importdata", {
                                            state: {
                                                module_name: "leads",
                                                fieldData: [
                                                    {
                                                        title: "General Fields",
                                                        fields: leadImportFields.map((c) => c),
                                                    },
                                                ],
                                            },
                                        });
                                    }}
                                    className="d-flex align-items-center">
                                    <FontAwesomeIcon
                                        icon={faFileImport}
                                        style={{ width: "16px", height: "16px", marginRight: "9px", color: "#5e5f60" }}
                                    />
                                    Import Data
                                </Dropdown.Item>
                                {
                                    (permissionAssigned === "can_download" || canEdit_canDownload) &&
                                    <Dropdown.Item
                                        onClick={() => {
                                            if (!leadGrant?.isExport) {
                                                toast.warning("You are not authorized for this action.")
                                                return
                                            }
                                            handleExportData([], "leads", headers, extras, setIsExporting)
                                        }}
                                        className="d-flex align-items-center"
                                    >
                                        <FontAwesomeIcon
                                            icon={faFileExport}
                                            style={{ width: "16px", height: "16px", marginRight: "9px", color: "#5e5f60" }}
                                        />
                                        Export Data
                                    </Dropdown.Item>
                                }
                                <Dropdown.Item href="#" className="d-flex align-items-center">
                                    <FontAwesomeIcon
                                        icon={faFileCsv}
                                        style={{ width: "16px", height: "16px", marginRight: "9px", color: "#5e5f60" }}
                                    />
                                    Template
                                </Dropdown.Item>
                                {/* Edit pipeline button */}

                                {selectedPipeline && (
                                    <Dropdown.Item onClick={() => {
                                        if (!leadPipelineGrant.isEdit) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        // handleEditPipeline()
                                        const encodedId = encodePipelineId(selectedPipelineId)
                                        setEncodedId(encodedId)
                                        setEditPipeline(true)
                                    }} className="d-flex align-items-center">
                                        <FontAwesomeIcon
                                            icon={faPencil}
                                            style={{ width: "16px", height: "16px", marginRight: "9px", color: "#5e5f60" }}
                                        />
                                        Edit Pipeline
                                    </Dropdown.Item>
                                )}
                                {
                                    added_by === customer.customer_details?.id &&
                                    <Dropdown.Item href="#" className="d-flex align-items-center text-start"
                                        onClick={() => {
                                            setShareModal(true)
                                        }}
                                    >
                                        <IconShare3 stroke={2} size={18} style={{ color: "#5e5f60", marginRight: "7px", }}></IconShare3>
                                        Share Pipeline
                                    </Dropdown.Item>
                                }
                                <Dropdown.Item href="#" className="d-flex align-items-center text-start"
                                    onClick={handleFbLeadSync}
                                >
                                    <IconShare3 stroke={2} size={18} style={{ color: "#5e5f60", marginRight: "7px", }}></IconShare3>
                                    Sync FB Leads
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                    {/* Add lead button */}
                    <Button
                        type="button"
                        className="btn btn-default"
                        style={{
                            height: "34px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => handleAddLead(selectedStageId)}
                    >
                        <FontAwesomeIcon icon={faPlus} className="pe-1" /> Add
                    </Button>
                </div>
            </div >
            <div
                style={{
                    textAlign: "end",
                    paddingRight: "3px",
                    color: "#8798adcc",
                    fontWeight: "300",
                    fontSize: "11px",
                    textTransform: "capitalize",
                    marginBottom: "14px",
                }}
            >
                Customize Column View | Filter Contact | Short by ascending & Descending Order | Current View: {heading}
            </div>
            {
                selectedPipelineId !== null && shareModal &&
                <PipelineShareModal
                    shareModal={shareModal}
                    onShareClose={() => {
                        setShareModal(false)
                        refetchLeads()
                    }}
                    module_name={"leads"}
                    pipelineId={selectedPipelineId}
                    sharedUsers={parsedSharedUsers}
                />
            }
        </>
    )
}

const Styles = {
    avatar: {
        border: "2px solid rgb(215 215 215)",
    },
}